import React, { useEffect, useState } from 'react';
import 'Home/Footer/footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import config from 'config';
import ToastMessage from 'Home/CommonResources/ToastMessage';
import { Popover } from 'react-tiny-popover'
import HomeApiCall from 'HomeApiCall';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import copyIC from 'Home/assets/ic.png'

const Footer = () => {
    const [showPopOver, setShowPopover] = useState(false);
    const [defaultNumber, setDefaultNumber] = useState("");
    const [primarySPOCNumber, setPrimarySPOCNumber] = useState("");

    useEffect(() => apiCallToGetCallerId(), [])

    const apiCallToGetCallerId = async () => {
        try {
            // Make an API call to retrieve caller IDs
            let jsonResponse = await HomeApiCall.makeApiCall(
                'getCallerIds',
                { instituteId: config.institute_id },
                '/api/helpDesk.php'
            );

            // Check if the response indicates that the session expired
            if (jsonResponse.expired) {
                // Retry the API call after a delay if the session expired
                setTimeout(() => this.apiCallToGetCallerId(), 1000);
            } else {
                // Process the response if the API call was successful
                if (jsonResponse.success) {
                    // Extract default and primary SPOC caller IDs from the response
                    const { defaultCallerId, primarySPOCCallerId } = jsonResponse.APIResult;

                    // Update UI with retrieved caller IDs
                    setDefaultNumber(defaultCallerId);
                    setPrimarySPOCNumber(primarySPOCCallerId);
                }
            }
        } catch (error) {
            // Handle any errors that occur during the API call
            console.error('Error in API call:', error);
        }
    }

    const renderPopoverContent = () => (
        <div className='popOverBody p-2'>
            {/* <div style={{ width: '100%', borderTop: '1px solid #7A7A7A', margin: '5px 0' }}></div> */}
            <div className="popoverBody mb-3">
                <label className='m-0 pt-2  labelText3'>Got questions? Dial us!</label>
            </div>
            <div className="d-flex align-items-center row justify-content-center mb-1">
                <label className='m-0 mr-4 labelText1'>{defaultNumber || ""}</label>
                <span style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(defaultNumber)}>
                    <img className="apple-icon cursor-pointer" style={{ width: 20, height: 20, alignSelf: 'center' }} src={copyIC} />
                </span>
            </div>
            {
                primarySPOCNumber != "" && (
                    <div className="d-flex align-items-center row justify-content-center">
                        <label className='m-0 mr-4 labelText1'>{primarySPOCNumber || ""}</label>
                        <span style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(primarySPOCNumber)}>
                            <img className="apple-icon cursor-pointer" style={{ width: 20, height: 20, alignSelf: 'center' }} src={copyIC} />
                        </span>
                    </div>
                )
            }
            <div className="popoverFooter mt-3">
                <label className='m-0 pt-2 labelText'>Please <label className='m-0 pt-2 text-danger labelText' style={{ textTransform: 'none !important' }}> do not save these virtual contact numbers,</label></label>

                <span className='m-0 pb-2 labelText'>as they may keep changing.  </span>
            </div>
        </div>
    )

    const copyToClipboard = (phoneNumber) => {
        try {
            navigator.clipboard.writeText(phoneNumber);
            setShowPopover(false); // Hide the popover after copying
            toast("Copied to clipboard successfully...");
        } catch (e) {
            console.log(e);
            toast("Failed to copy...");
        }
    };


    return (
        <footer id="sticky-footer footer" className="big">
            <div className="footer-container">
                <a style={{ float: 'left' }} href={`${config.RootUrl}/modules/helpdesk/#/help/productDocumentation`} target="_blank" rel="noopener noreferrer" className="footer-link ml-4">
                    <span className="helpBtn">
                        Product Documentation
                    </span>
                </a>

                <Popover
                    isOpen={showPopOver}
                    padding={5}
                    arrowSize={10}
                    arrowColor="#000000"
                    containerStyle={{ borderRadius: 10 }}
                    positions={['top', 'right']} // preferred positions by priority
                    onClickOutside={() => setShowPopover(false)}
                    content={renderPopoverContent()}
                >
                    <button className="contactBtn ml-2 mb-1" style={{ float: 'left' }} type="button" onClick={() => setShowPopover(!showPopOver)}>
                        <FontAwesomeIcon className="apple-icon" icon={['fa', 'phone-alt']} size="xs" />
                        <span className="contactBtn">
                            Contact US
                        </span>
                    </button>
                </Popover>
                <span className="footer-data download">Download App
                    <a href="https://play.google.com/store/apps/details?id=com.vmedulifeapp&hl=en_IN" target="_blank" rel="noopener noreferrer" className="footer-link">
                        <span className="footer-data download">
                            <img style={{ height: 16 }} className='android-logo ml-2 img-fluid' src={process.env.PUBLIC_URL + "/assets/images/andorid_icon.png"} alt="image" />
                        </span>
                    </a>
                    <a href="https://apps.apple.com/app/vmedulife/id1606317107" target="_blank" rel="noopener noreferrer" className="footer-link">
                        <span className="footer-data download ml-2">
                            <FontAwesomeIcon className="apple-icon p-0" icon={['fab', 'apple']} size="lg" />
                        </span>
                    </a>
                </span>
                <a href="https://vmedulife.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="footer-link">
                    <span className="footer-data policy">Privacy Policy</span>
                </a>
                <a href="https://vmedulife.com/terms-of-service" target="_blank" rel="noopener noreferrer" className="footer-link">
                    <span className="footer-data terms">Terms of Use</span>
                </a>
                <a href="https://vmedulife.com/" target="_blank" rel="noopener noreferrer" className="footer-link">
                    <span className="footer-data powered-by">
                        Powered by <span className="vm">vm</span><span className="edu">edu</span><span className="life">life</span>
                    </span>
                </a>
            </div>
            <ToastContainer />
        </footer>
    );
}

export default Footer;